var map = {
	"./panel-alerts-inferior-en.png": 88681,
	"./panel-alerts-inferior-es.png": 58396,
	"./panel-alerts-superior-en.png": 3740,
	"./panel-alerts-superior-es.png": 68649,
	"./panel-assignment-to-accept-en.png": 47333,
	"./panel-assignment-to-accept-es.png": 13056,
	"./panel-assignments-inferior-en.png": 6126,
	"./panel-assignments-inferior-es.png": 61659,
	"./panel-assignments-superior-en.png": 67311,
	"./panel-assignments-superior-es.png": 80090,
	"./panel-example-en.png": 91351,
	"./panel-example-es.png": 98386,
	"./panel-example-signatures-en.png": 37727,
	"./panel-example-signatures-es.png": 78538,
	"./panel-notifications-inferior-en.png": 22376,
	"./panel-notifications-inferior-es.png": 10141,
	"./panel-notifications-superior-en.png": 16765,
	"./panel-notifications-superior-es.png": 59624,
	"./panel-signatures-inferior-en.png": 95361,
	"./panel-signatures-inferior-es.png": 88548,
	"./panel-signatures-superior-en.png": 57364,
	"./panel-signatures-superior-es.png": 19217,
	"./panel-tooltip-en.png": 60158,
	"./panel-tooltip-es.png": 85227
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 15897;